class HooksManager {
    hooks: {
        id: string,
        hook: string,
        callback: (...params: any[]) => void
    }[]

    constructor() {
        this.hooks = []
    }
    
    triggerHook = (instance: JQuery, hook: string, ...params: any[]) => {
        const id = instance.attr('id')
        if (!id) return
        this.hooks.forEach(it => {
            if (it.id === id && it.hook === hook) {
                it.callback(...params)
            }
        })
    }
    
    /**
     * Possible hooks:
     * - onItemAdded (itemView: JQuery)
     * - onItemRemoved (itemView: JQuery)
     * - onPreUpdate (<no parameters>)
     * - onPostUpdate (<no parameters>)
     */
    addHook = (instance: JQuery, hook: string, callback: (...params: any[]) => void) => {
        const id = instance.attr('id')
        if (!id) return
        this.hooks.push({ id, hook, callback })
    }
}

export default HooksManager

export const instance = new HooksManager()